import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['iframe', 'button']
  static values = {
    muted: Boolean,
    muteText: String,
    unmuteText: String,
  }

  connect() {
    if (!this.hasMutedValue) {
      this.mutedValue = true;
    }

    this.player = null;
    this.playerReady = false;
    this.buttonTarget.disabled = true;

    this.waitForYouTubeAPI();
  }

  disconnect() {
    if (this.player) {
      this.player.destroy();
      this.player = null;
    }
  }

  toggleMute(event) {
    event.preventDefault()

    if (!this.playerReady) {
      return
    }

    this.mutedValue = !this.mutedValue

    if (this.mutedValue) {
      this.player.mute()
    } else {
      this.player.unMute()
    }

    this.updateButtonLabel()
  }

  // private

  waitForYouTubeAPI() {
    if (window.YT && window.YT.Player) {
      this.createPlayer();
      return;
    }

    const previous = window.onYouTubeIframeAPIReady

    window.onYouTubeIframeAPIReady = () => {
      if (previous) previous();
      this.createPlayer();
    }
  }

  createPlayer() {
    this.player = new window.YT.Player(this.iframeTarget, {
      events: {
        onReady: this.onPlayerReady.bind(this),
      },
    })
  }

  onPlayerReady() {
    this.playerReady = true

    if (this.mutedValue) {
      this.player.mute();
    } else {
      this.player.unMute();
    }

    this.buttonTarget.disabled = false;
    this.updateButtonLabel();
  }

  updateButtonLabel() {
    this.buttonTarget.textContent = this.mutedValue ? this.unmuteTextValue : this.muteTextValue
  }
}
